var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 17.5H31.4C32.2837 17.5 33 18.3395 33 19.375V30.625C33 31.6605 32.2837 32.5 31.4 32.5H18.6C17.7163 32.5 17 31.6605 17 30.625V19.375C17 18.3395 17.7163 17.5 18.6 17.5ZM30.2812 23.5H19.7188C19.0457 23.5 18.5 24.0876 18.5 24.8125V25.25H22.226C22.4414 25.25 22.6481 25.3422 22.8005 25.5063L23.613 26.3813C23.9808 26.7774 24.4798 27 25 27C25.5202 27 26.0192 26.7774 26.387 26.3813L27.1995 25.5063C27.3519 25.3422 27.5586 25.25 27.774 25.25H31.5V24.8125C31.5 24.0876 30.9543 23.5 30.2812 23.5ZM18.5 21.5C18.5 20.6716 19.0457 20 19.7188 20H30.2812C30.9543 20 31.5 20.6716 31.5 21.5V22H18.5V21.5Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon12);
export default __webpack_public_path__ + "static/media/nav_icon_12.41959c6693e973e0d1af9818d68adb66.svg";
export { ForwardRef as ReactComponent };